/** Shared Tailwind classes for reports list filter drawers and form controls. */

export const LABEL_CLASS =
  'text-xs font-semibold uppercase tracking-wide text-slate-500'

/**
 * Height of filter controls — matches SearchableSelect trigger (`h-[38px]`).
 */
export const FILTER_CONTROL_HEIGHT_CLASS = 'h-[38px] min-h-[38px]'

/**
 * Text inputs in report filter drawers.
 */
export const INPUT_CLASS = [
  'w-full',
  FILTER_CONTROL_HEIGHT_CLASS,
  'rounded-xl border border-slate-200 bg-white px-3 text-sm text-slate-800 shadow-sm',
  'focus:border-[rgb(21_151_255)] focus:outline-none focus:ring-2 focus:ring-[rgb(21_151_255)]/15',
].join(' ')

/**
 * Native `<select>` in report filters.
 * Fixed height + no vertical padding so the selected/placeholder option is
 * vertically centered (unlike `min-h + py-3`, which sits text too high).
 */
export const FILTER_SELECT_CLASS = [
  'w-full',
  FILTER_CONTROL_HEIGHT_CLASS,
  'box-border rounded-xl border border-slate-200 bg-white px-3 py-0 text-sm leading-[38px] text-slate-800 shadow-sm',
  'focus:border-[rgb(21_151_255)] focus:outline-none focus:ring-2 focus:ring-[rgb(21_151_255)]/15',
].join(' ')

/** @deprecated Prefer {@link FILTER_SELECT_CLASS} for native selects. */
export const SELECT_CLASS = FILTER_SELECT_CLASS

export const REPORT_ACTION_ICON_LINK_CLASS =
  'inline-flex h-8 w-8 items-center justify-center rounded-lg border border-slate-200 bg-white text-slate-600 shadow-sm transition hover:border-slate-300 hover:bg-slate-50 hover:text-[rgb(21_151_255)]'

/**
 * Primary toolbar Export control (matches Default Payment Logs / Filters height).
 */
export const REPORT_EXPORT_BUTTON_CLASS = [
  'inline-flex flex-1 items-center justify-center gap-2 rounded-xl',
  'bg-[rgb(21_151_255)] px-5 py-2.5 text-sm font-semibold text-white shadow-sm',
  'transition-all hover:bg-[#0d7acc] hover:shadow-md',
  'disabled:cursor-not-allowed disabled:opacity-60 md:flex-none',
].join(' ')

/**
 * Default trigger chrome for ReportDateRangePicker inside filter drawers
 * (aligned to SearchableSelect / FILTER_SELECT_CLASS height).
 */
export const FILTER_DATE_TRIGGER_CLASS =
  '!h-[38px] !min-h-[38px] !rounded-xl !border-slate-200 !bg-white !py-0 !text-sm !leading-[38px] !text-slate-800 !shadow-sm focus:!border-[rgb(21_151_255)] focus:!ring-2 focus:!ring-[rgb(21_151_255)]/15'
